<template lang="pug">
  #sitewide
    WtTile(ancestor)
      WtTile(
        vertical
        parent
        :col="coreProgramMeta.allowJournals && coreProgramMeta.communityFeedEnabled !== false ? 5 : 12"
      )
        WtTile.is-sticky-on-scroll(
          child
          :col="12"
          :is-loading="(activeTab === 0 && !aggregateDataLoaded) || (activeTab === 1 && !stepDataLoaded) || (activeTab === 2 && !leaderboardLoaded)"
        )
          WtTitle(card-title) My Program
          BTabs(v-model="activeTab")
            template(v-for="tab in ['Stats', 'Chart', 'Snapshot']")
              BTabItem(:key="tab" :label="tab")
          ProgramStats(
            v-if="activeTab === 0"
            :program-data="aggregateData"
          )
          StepsChart(
            v-if="activeTab === 1"
            :data="stepData"
            :loaded-status="stepDataLoaded"
          )
          WtLeaderboard(
            v-if="activeTab === 2"
            title="Sitewide Snapshot"
            sub-title="Seven Day Rolling Average"
            :data="leaderboard"
            :loaded-status="leaderboardLoaded"
          )

      WtTile.sitewide-container(parent :col="7" v-if="coreProgramMeta.id && coreProgramMeta.allowJournals && coreProgramMeta.communityFeedEnabled")
        WtTile.sitewide-view(child :col="12" :is-loading="!organizationFeedPostsLoaded")
          FeedPosts(
            title="Newsfeed"
            :feed-data="organizationFeedPosts"
            :is-last-page="isOrganizationFeedLastPage"
            :loaded="organizationFeedPostsLoaded"
            :fetch-action="fetchSitewideNewsfeed"
            :can-manage="false"
            :is-site-wide="true"
            :organization-id="coreProgramMeta.id"
            empty-state-text="No posts available in the newsfeed."
          )
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { fetchAllMixin } from "@/mixins/fetchAllMixin";
import Journal from "@/components/Members/Journal.vue";
import FeedPosts from "@@/Members/FeedPosts/FeedPosts";
import ProgramCard from "@/components/Program/ProgramCard.vue";
import StepsChart from "@/components/Program/StepsChart.vue";
import WtLeaderboard from "@@/WtLeaderboard/WtLeaderboard";
import ProgramStats from "@/components/Program/ProgramStats";
import WtFullPageLoader from "@@/WtFullPageLoader/WtFullPageLoader";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";

export default {
  name: "Sitewide",

  components: {
    ProgramStats,
    WtTile,
    WtTitle,
    Journal,
    FeedPosts,
    ProgramCard,
    StepsChart,
    WtLeaderboard,
    WtFullPageLoader
  },

  mixins: [analyticsTrackingMixin, dateUtilityMixin, fetchAllMixin],

  data() {
    return {
      page: `Sitewide`,
      activeTab: 0
    };
  },

  computed: {
    ...mapGetters("pages", ["isPageLoaded", "isPageLoading"]),
    ...mapGetters("program", [
      "programLoaded",
      "coreProgramMeta",
      "isJournalLastPage",
      "journals",
      "journalsLoaded",
      "stepData",
      "stepDataLoaded",
      "leaderboard",
      "leaderboardLoaded",
      "aggregateData",
      "aggregateDataLoaded"
    ]),
    ...mapGetters("feed", [
      "organizationFeedPosts",
      "organizationFeedPostsLoaded",
      "isOrganizationFeedLastPage"
    ]),

    fullPageLoader() {
      // since there is no initial state for 'isPageLoading(this.page)'
      if (this._.isUndefined(this.isPageLoading(this.page))) {
        return true;
      }
      return this.isPageLoading(this.page);
    }
  },

  mounted() {
    this.trackFeatureView("community", "community_feed");
  },

  methods: {
    ...mapActions("pages", [
      "setPageLoaded",
      "setPageLoading",
      "fetchAllPageSitewide"
    ]),
    ...mapActions("program", ["fetchJournals"]),
    ...mapActions("feed", ["fetchOrganizationFeedPosts"]),

    fetchProgramJournals(
      photosOnly = false,
      friends = false,
      page = null,
      resetList = false
    ) {
      return this.fetchJournals({
        programId: this.coreProgramMeta.id,
        photosOnly,
        friends,
        page,
        resetList
      });
    },

    fetchSitewideNewsfeed(
      page = null,
      resetList = false,
      photosOnly = false,
      friends = false
    ) {
      return this.fetchOrganizationFeedPosts({
        programId: this.coreProgramMeta.id,
        page,
        resetList,
        photosOnly,
        friends
      });
    },

    async fetchAllPage(vm) {
      const programId = this.$auth.user().programId;

      await vm.fetchAllPageSitewide(programId);
    }
  },

  beforeRouteEnter(to, _, next) {
    next(async vm => {
      await vm.toFetchOrNotToFetch(vm, to.name);
    });
  }
};
</script>

<style lang="sass" scoped>
.sitewide-view
  background-color: #E8EBEF
.sitewide-container
  background-color: #E8EBEF
  border-radius: 12px
</style>
